import { render, staticRenderFns } from "./TraderCof.vue?vue&type=template&id=13f97b6c&scoped=true&"
import script from "./TraderCof.vue?vue&type=script&lang=js&"
export * from "./TraderCof.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=13f97b6c&lang=less&scoped=true&"
import style1 from "./TraderCof.vue?vue&type=style&index=1&id=13f97b6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f97b6c",
  null
  
)

export default component.exports